<template>
<div v-if="viewType === 'SETTING'">
  <w-common-obj-list ref="commonObjList" type="logical" :load-obj-list="true" :load-params="loadParams" @change-obj-list="changeObjList">
    <template slot="title">
      <div class="title-h4 mr-r10">
        대상 장비 선택
      </div>
      <span class="info-text" style="font-size:13px;">최대 5개의 장비를 선택할 수 있습니다.</span>
    </template>
  </w-common-obj-list>
  <!-- <el-row v-show="false" class="title-bar vertical-center-box" type="flex" justify="space-between">
    <div>
      <div class="title-h4 mr-r4">대상 장비 선택</div>
      <span class="info-text" style="font-size:13px;">최대 5개의 장비를 선택할 수 있습니다.</span>
    </div>
    <w-search-field width="200px" @search="filterTree" />
  </el-row>
  <el-tree v-show="false" class="tree-checkbox" :default-expanded-keys="['1']" :ref="treeRef" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" show-checkbox @check-change="treeCheckChange" :filter-node-method="filterNode">
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <span>{{isObjNode(data) && isRequireIPObjType(data) ? getObjNodeLabel(data) : data.label}}</span>
    </span>
  </el-tree> -->
</div>
<div v-else-if="viewType === 'INFO'" class="wrapper">
  <el-form-item label="대상 장비">
    <ul>
      <li v-for="item in optionInfo" :key="item.objId">{{ item.objName }}</li>
    </ul>
  </el-form-item>
</div>
<div v-else class="wrapper">
  <el-form-item label="대상 장비">
    <ul>
      <li v-for="item in previewOptionInfo" :key="item.objId">{{ item.objName }}</li>
    </ul>
  </el-form-item>
</div>
</template>

<script>
import { isEmpty, map } from 'lodash';
import { defaultProps } from '@/constants/tree';
import LogicalGroupAPI from '@/api/settings/common/logical-group';
import msgUtil from '@/utils/message';
import WSearchField from '@/components/form/SearchField';
import WCommonObjList from '@/components/table/CommonObjList';

export default {
  name: 'WWatchallObjsTree',
  components: {
    WSearchField,
    WCommonObjList,
  },
  props: {
    defaultValue: {
      type: Array,
    },
    defaultSetList: {
      type: Object,
      default: () => {},
    },
    viewType: {
      type: String,
      default: () => 'SETTING',
    },
    optionInfo: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    loadParams() {
      if (isEmpty(this.defaultValue)) {
        return {};
      }
      return {
        objIds: this.defaultValue,
      };
    },
  },
  data() {
    return {
      treeRef: 'targetTree',
      detailInfo: [],
      objList: [],
      defaultProps,
      treeData: [],
      previewOptionInfo: [],
      lengthObjList: 0,
      changeFlag: false,
    };
  },
  methods: {
    changeObjList(objList) {
      this.objList = objList;
      this.previewOptionInfo = objList;
      if (this.changeFlag) {
        this.lengthObjList = this.objList.length;
      }
    },
    initData(infoFlag) {
      if (!infoFlag) {
        this.$refs.commonObjList.loadData();
        this.detailInfo = this.defaultValue;
      }
      this.changeFlag = false;
      LogicalGroupAPI.getLogicalObjList({ objIds: this.detailInfo }).then((response) => {
        const result = response.data;
        if (result.success) {
          this.previewOptionInfo = result.data;
          this.changeFlag = true;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '대상 장비', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '대상 장비', false));
        this.previewOptionInfo = [];
      });
    },
    getData() {
      if (this.objList.length === 0) {
        this.$message(msgUtil.getCustomMsgData('관리 대상을 선택해 주십시오.'));
        return false;
      } else if (this.objList.length > 5) {
        this.$message(msgUtil.getCustomMsgData('관리 대상은 최대 5개까지 선택 가능합니다.'));
        return false;
      }
      return {
        WATCHALL_OBJS: map(this.objList, 'objId'),
      };
    },
    getDetailData() {
      return {
        WATCHALL_OBJS: this.objList,
      };
    },
    setOptionInfo(defaultValue) {
      this.previewOptionInfo = [];
      this.detailInfo = defaultValue;
      this.initData(true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/attr/WatchallObjsTree.vue